import { useAnalyticsTrack } from '@chr/react-analytics';

export const useAdobeActions = () => {
  const track = useAnalyticsTrack();
  const language = navigator.language;

  const handleAdobeAction = (name: string, event: string, label: string) => {
    track({
      event: "userActions",
      infoUI: {
        name: name,
        type: event,
        label: label,
      },
      site: {
        language: language,
        name: "Online.ExternalTracking.UI",
      },
    });
  };

  return { handleAdobeAction };
};